// extracted by mini-css-extract-plugin
module.exports = {"search-filter":"gxNzd5ukzUqoBPBGfvIg7","label-margin":"cnzK0r9Zpwxk6vRvGbIR_"};